// Global Types
import type {
  $Config as $ApiServiceConfig,
} from '@vroskus/library-api';
import type {
  $TrackerRouteRequest as $ApiRouteRequest,
  $TrackerRouteResponse as $ApiRouteResponse,
} from 'common.types';

// Helpers
import Api from '@vroskus/library-api';

// Types
export type $Config = $ApiServiceConfig;

class TrackerService<C extends $ApiServiceConfig> extends Api<C> {
  async getPositions(
    params: $ApiRouteRequest<'/position/get_many'>['query'],
  ): Promise<$ApiRouteResponse<'/position/get_many'>> {
    const response = await this.connection.get(
      '/position/get_many',
      {
        params,
      },
    );

    return response.data;
  }
}

export default TrackerService;
